module.exports = __webpack_public_path__ + "static/img/Frame 1850.78f1f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1850.png
// module id = Oc5x
// module chunks = 12